/* Protein Bodega SIMPLE — cart patch v5 (plans-only theme)
   Every control is a NATIVE SELECT so the chosen value is always visible.
   Plan lines: how often (one time or weekly subscription, switchable here) and a
   required meal style. Add on lines: delivery day. Order details: a required
   allergy answer with a required details box when the answer is yes, plus an
   optional requests box. */
(function () {
  'use strict';

  var WEEKLY_SELLING_PLAN = 5518688482;
  var ADDON_TAGS = ['add-ons', 'snacks', 'treat-yourself', 'wellness', 'breakfast'];
  var NOT_ADDON = ['meals', 'merch', 'plan', 'meal-plan', 'membership'];
  var PLAN_FALLBACK = ['48248716886242', '48248717541602'];
  var DAYS = ['Sunday', 'Wednesday'];
  var OURS = /^(delivery day|meal style|plan|purchase type)\s*:?/i;

  var CART = { items: [] };
  var ADDON = null;
  var PLAN = null;

  var CSS = [
    '#pb-upsell-section,.pb-upsell-wrap,.pb-plan-cta,.pb-member-bar,[data-pb-member-bar]{display:none!important}',
    '.pb-delivery-row{display:none!important}',
    'quantity-selector-component,.quantity-selector{border:0!important;outline:0!important;background:transparent!important;box-shadow:none!important}',
    '.pbs-block{display:block;margin:12px 0 2px;max-width:380px}',
    '.pbs-block.busy{opacity:.5;pointer-events:none}',
    '.pbs-fld{margin:0 0 10px}',
    '.pbs-fld label{display:block;font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#7C766A;margin-bottom:5px}',
    '.pbs-fld label.req:after{content:" *";color:#E23A2B;font-weight:900}',
    '.pbs-fld select{width:100%;padding:11px 12px;border:1.5px solid #cfc3a8;border-radius:10px;background:#fff;font-family:inherit;font-size:13px;font-weight:600;color:#141210;cursor:pointer}',
    '.pbs-fld select.missing{border-color:#E23A2B;background:#fff6f4}',
    '.pbs-fld select:focus{outline:2px solid #0B6B3A;outline-offset:1px}',
    '.pbs-fld .hint{display:block;margin-top:5px;font-size:11px;color:#7C766A;line-height:1.4}',
    '.pbs-plan-note{display:block;margin:8px 0 2px;font-size:11.5px;font-weight:600;color:#7C766A;line-height:1.35;max-width:340px}',
    '.pbs-notes{margin:16px 0 12px;padding:16px;border-radius:12px;background:#151515;color:#f4f1ea}',
    '.pbs-notes h3{margin:0 0 12px;font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#fff}',
    '.pbs-notes .fld{margin-bottom:14px}',
    '.pbs-notes label.hd{display:block;font-size:11px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#cfc9bd;margin-bottom:6px}',
    '.pbs-notes label.hd.req:after{content:" *";color:#ff8a7a;font-weight:900}',
    '.pbs-notes select{width:100%;padding:11px 12px;border-radius:8px;border:1.5px solid #3a3a3a;background:#0e0e0e;color:#f4f1ea;font-size:13px;font-family:inherit;font-weight:600;cursor:pointer}',
    '.pbs-notes select.missing{border-color:#ff8a7a}',
    '.pbs-notes textarea{width:100%;min-height:52px;border-radius:8px;border:1.5px solid #3a3a3a;background:#0e0e0e;color:#f4f1ea;padding:9px 10px;font-size:13px;font-family:inherit;resize:vertical}',
    '.pbs-notes textarea.missing{border-color:#ff8a7a}',
    '.pbs-warn{display:none;margin:10px 0 0;font-size:12.5px;font-weight:700;color:#ff8a7a}',
    '.pbs-warn.on{display:block}',
    '.cart__checkout-button[disabled]{opacity:.45;cursor:not-allowed}'
  ].join('\n');

  function css() {
    var s = document.getElementById('pbs-cart-css');
    if (!s) {
      s = document.createElement('style');
      s.id = 'pbs-cart-css';
      document.head.appendChild(s);
    }
    if (s.textContent !== CSS) s.textContent = CSS;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function loadCatalog() {
    if (ADDON && PLAN) return Promise.resolve();
    return fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var addon = {}, plan = {};
        (d.products || []).forEach(function (p) {
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var ptype = String(p.product_type || '').toLowerCase();
          var isPlan = ptype.indexOf('meal plan') !== -1 ||
                       tags.indexOf('plan') !== -1 || tags.indexOf('meal-plan') !== -1;
          var blocked = NOT_ADDON.some(function (t) { return tags.indexOf(t) !== -1; });
          var isAddon = !blocked && ADDON_TAGS.some(function (t) { return tags.indexOf(t) !== -1; });
          (p.variants || []).forEach(function (v) {
            if (isAddon) addon[String(v.id)] = true;
            if (isPlan) plan[String(v.id)] = true;
          });
        });
        if (Object.keys(plan).length === 0) PLAN_FALLBACK.forEach(function (id) { plan[id] = true; });
        ADDON = addon; PLAN = plan;
      })
      .catch(function () {
        ADDON = {}; PLAN = {};
        PLAN_FALLBACK.forEach(function (id) { PLAN[id] = true; });
      });
  }

  function lineByKey(key) {
    for (var i = 0; i < CART.items.length; i++) {
      if (CART.items[i].key === key) return CART.items[i];
    }
    return null;
  }

  function propsOf(key) {
    var l = lineByKey(key);
    var out = {};
    if (l && l.properties) Object.keys(l.properties).forEach(function (k) { out[k] = l.properties[k]; });
    return out;
  }

  function setProps(key, changes, wrap) {
    if (wrap) wrap.classList.add('busy');
    var props = propsOf(key);
    Object.keys(changes).forEach(function (k) {
      if (changes[k] === null) delete props[k];
      else props[k] = changes[k];
    });
    return post('/cart/change.js', { id: key, properties: props })
      .then(function () { window.location.reload(); })
      .catch(function () { if (wrap) wrap.classList.remove('busy'); });
  }

  function setFrequency(key, wantSub, wrap) {
    var line = lineByKey(key);
    if (!line) return;
    if (wrap) wrap.classList.add('busy');
    var props = {};
    if (line.properties) Object.keys(line.properties).forEach(function (k) { props[k] = line.properties[k]; });
    var item = { id: line.variant_id, quantity: line.quantity || 1, properties: props };
    if (wantSub) item.selling_plan = WEEKLY_SELLING_PLAN;
    post('/cart/add.js', { items: [item] })
      .then(function () { return post('/cart/change.js', { id: key, quantity: 0 }); })
      .then(function () { window.location.reload(); })
      .catch(function () { if (wrap) wrap.classList.remove('busy'); });
  }

  function hideDupes() {
    document.querySelectorAll('[data-key] *').forEach(function (el) {
      if (el.childElementCount !== 0) return;
      if (el.closest('.pbs-block') || el.closest('.pbs-notes')) return;
      var t = (el.textContent || '').trim();
      if (!t || t.length > 60 || !OURS.test(t)) return;
      var box = el.closest('dd, dt, li, p, div') || el;
      if (box.closest('.pbs-block')) return;
      box.style.display = 'none';
    });
  }

  function killLeftovers() {
    var el = document.getElementById('pb-upsell-section');
    if (el) el.remove();
    document.querySelectorAll('.pb-upsell-wrap, .pb-delivery-row').forEach(function (n) { n.remove(); });

    document.querySelectorAll('h1,h2,h3,h4,p,span').forEach(function (h) {
      if (h.childElementCount !== 0) return;
      var t = (h.textContent || '').trim().toLowerCase();
      if (t !== 'you may also like' && t !== 'you might also like') return;
      var box = h.closest('section, .shopify-section, [class*="upsell"], [class*="recommend"]') || h.parentElement;
      if (box) box.remove(); else h.remove();
    });

    var needles = ['unlock member pricing', 'get a meal plan', 'member pricing'];
    document.querySelectorAll('.cart-page *, .cart-drawer *, main *').forEach(function (el2) {
      if (el2.children.length > 3 || el2.getAttribute('data-pb-killed')) return;
      var t = (el2.textContent || '').trim().toLowerCase();
      if (!t || t.length > 80) return;
      for (var j = 0; j < needles.length; j++) {
        if (t.indexOf(needles[j]) !== -1) {
          var box = el2.closest('[class*="plan-cta"],[class*="member"],[class*="upsell-plan"]') || el2.parentElement;
          if (box) { box.setAttribute('data-pb-killed', '1'); box.style.display = 'none'; }
          return;
        }
      }
    });
  }

  /* ---------- plan lines ---------- */
  function mountPlan() {
    if (!PLAN) return;
    document.querySelectorAll('[data-key]').forEach(function (row) {
      var key = String(row.getAttribute('data-key') || '');
      var vid = key.split(':')[0];
      var existing = row.querySelector('.pbs-planbox');
      if (!PLAN[vid]) { if (existing) existing.remove(); return; }
      row.querySelectorAll('.pb-delivery-row, .pbs-day').forEach(function (n) { n.remove(); });

      var line = lineByKey(key);
      var isSub = !!(line && line.selling_plan_allocation);
      var style = propsOf(key)['Meal style'] || '';

      if (existing) {
        var f = existing.querySelector('.pbs-freqsel');
        var s = existing.querySelector('.pbs-stylesel');
        if (f && f.value !== (isSub ? 'sub' : 'once')) f.value = isSub ? 'sub' : 'once';
        if (s && s.value !== style) s.value = style;
        if (s) s.classList.toggle('missing', !style);
        return;
      }

      var box = document.createElement('div');
      box.className = 'pbs-block pbs-planbox';
      box.innerHTML =
        '<div class="pbs-fld">' +
        '<label>How often</label>' +
        '<select class="pbs-freqsel">' +
        '<option value="once">One time, just this week</option>' +
        '<option value="sub">Weekly subscription, repeats every week</option>' +
        '</select>' +
        '<span class="hint">' + (isSub ? 'Billed weekly. Skip or cancel anytime from your account.' : 'A single week. Nothing repeats.') + '</span>' +
        '</div>' +
        '<div class="pbs-fld">' +
        '<label class="req">Meal style</label>' +
        '<select class="pbs-stylesel' + (style ? '' : ' missing') + '">' +
        '<option value="">Choose one</option>' +
        '<option value="Regular">Regular meals</option>' +
        '<option value="Low calorie">Low calorie, no carbs and extra veggies</option>' +
        '</select>' +
        '</div>';

      var host = row.querySelector('.cart-items__details') || row;
      host.appendChild(box);

      var freq = box.querySelector('.pbs-freqsel');
      freq.value = isSub ? 'sub' : 'once';
      freq.addEventListener('change', function () {
        setFrequency(key, freq.value === 'sub', box);
      });

      var sel = box.querySelector('.pbs-stylesel');
      sel.value = style;
      sel.addEventListener('change', function () {
        if (!sel.value) return;
        setProps(key, { 'Meal style': sel.value }, box);
      });
    });
  }

  /* ---------- add on lines ---------- */
  function mountDays() {
    if (!ADDON) return;
    document.querySelectorAll('[data-key]').forEach(function (row) {
      var key = String(row.getAttribute('data-key') || '');
      var vid = key.split(':')[0];
      if (!ADDON[vid]) {
        row.querySelectorAll('.pbs-day').forEach(function (n) { n.remove(); });
        return;
      }
      if (propsOf(key)['_pb_november_bundle'] === '2026') {
        row.querySelectorAll('.pbs-day').forEach(function (n) { n.remove(); });
        return;
      }
      var current = propsOf(key)['Delivery Day'] || '';
      var existing = row.querySelector('.pbs-day');
      if (existing) {
        var s = existing.querySelector('select');
        if (s && s.value !== current) s.value = current;
        return;
      }

      var wrap = document.createElement('div');
      wrap.className = 'pbs-block pbs-day';
      var opts = '<option value="">Pick a day</option>';
      DAYS.forEach(function (d) { opts += '<option value="' + d + '">' + d + '</option>'; });
      wrap.innerHTML = '<div class="pbs-fld"><label>Delivery day</label><select>' + opts + '</select></div>';

      var host = row.querySelector('.cart-items__details') || row;
      host.appendChild(wrap);

      var sel = wrap.querySelector('select');
      sel.value = current;
      sel.addEventListener('change', function () {
        setProps(key, { 'Delivery Day': sel.value }, wrap);
      });
    });
  }

  function planNotes() {
    CART.items.forEach(function (it) {
      if (!it.properties || !it.properties['Plan']) return;
      var row = document.querySelector('[data-key="' + it.key + '"]');
      if (!row || row.querySelector('.pbs-plan-note')) return;
      var n = document.createElement('span');
      n.className = 'pbs-plan-note';
      n.textContent = 'Chef curated meals · delivered Sunday and Wednesday';
      var host = row.querySelector('.cart-items__details') || row;
      host.insertBefore(n, host.firstChild);
    });
  }

  /* ---------- order details ---------- */
  function attr(k) { return (CART.attributes && CART.attributes[k]) || ''; }

  function saveAttrs() {
    var sel = document.getElementById('pbs-allergy');
    var det = document.getElementById('pbs-allergy-det');
    var req = document.getElementById('pbs-req');
    return post('/cart/update.js', {
      attributes: {
        'Allergies': sel ? sel.value : '',
        'Allergy details': sel && sel.value === 'Yes' && det ? det.value.trim() : '',
        'Special requests': req ? req.value.trim() : ''
      }
    }).catch(function () {});
  }

  function mountNotes() {
    if (document.getElementById('pbs-notes')) return;
    var ctas = document.querySelector('.cart-page__summary .cart__ctas') || document.querySelector('.cart__ctas');
    if (!ctas) return;

    var box = document.createElement('div');
    box.className = 'pbs-notes';
    box.id = 'pbs-notes';
    box.innerHTML =
      '<h3>Order details</h3>' +
      '<div class="fld">' +
      '<label class="hd req" for="pbs-allergy">Any allergies?</label>' +
      '<select id="pbs-allergy">' +
      '<option value="">Choose one</option>' +
      '<option value="None">No allergies</option>' +
      '<option value="Yes">Yes, I have allergies</option>' +
      '</select>' +
      '<div id="pbs-allergy-wrap" style="display:none;margin-top:9px">' +
      '<label class="hd req" for="pbs-allergy-det">Which allergies?</label>' +
      '<textarea id="pbs-allergy-det" placeholder="Tell us exactly what to avoid…"></textarea>' +
      '</div>' +
      '</div>' +
      '<div class="fld">' +
      '<label class="hd" for="pbs-req">Specifications or other requests</label>' +
      '<textarea id="pbs-req" placeholder="Sauce on the side, no onions…"></textarea>' +
      '</div>' +
      '<p class="pbs-warn" id="pbs-warn"></p>';
    ctas.insertAdjacentElement('beforebegin', box);

    var sel = box.querySelector('#pbs-allergy');
    var det = box.querySelector('#pbs-allergy-det');
    var wrap = box.querySelector('#pbs-allergy-wrap');
    var req = box.querySelector('#pbs-req');

    sel.value = attr('Allergies');
    det.value = attr('Allergy details');
    req.value = attr('Special requests');
    wrap.style.display = sel.value === 'Yes' ? 'block' : 'none';

    sel.addEventListener('change', function () {
      wrap.style.display = sel.value === 'Yes' ? 'block' : 'none';
      if (sel.value !== 'Yes') det.value = '';
      saveAttrs();
      sync();
    });
    [det, req].forEach(function (f) {
      f.addEventListener('input', sync);
      f.addEventListener('blur', saveAttrs);
    });
  }

  function problem() {
    if (PLAN) {
      for (var i = 0; i < CART.items.length; i++) {
        var it = CART.items[i];
        if (!PLAN[String(it.variant_id)]) continue;
        if (!it.properties || !it.properties['Meal style']) {
          return 'Choose regular or low calorie for your meal plan before checking out.';
        }
      }
    }
    var sel = document.getElementById('pbs-allergy');
    if (!sel || !sel.value) return 'Answer the allergy question before checking out.';
    if (sel.value === 'Yes') {
      var det = document.getElementById('pbs-allergy-det');
      if (!det || det.value.trim().length < 2) return 'Tell us which allergies so the kitchen can work around them.';
    }
    return '';
  }

  function sync() {
    var msg = problem();
    document.querySelectorAll('.cart__checkout-button, button[name="checkout"], #checkout').forEach(function (b) {
      if (msg) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
    });
    var warn = document.getElementById('pbs-warn');
    if (warn) { warn.textContent = msg; warn.classList.toggle('on', !!msg); }
    var sel = document.getElementById('pbs-allergy');
    if (sel) sel.classList.toggle('missing', !sel.value);
    var det = document.getElementById('pbs-allergy-det');
    if (det && sel) det.classList.toggle('missing', sel.value === 'Yes' && det.value.trim().length < 2);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.cart__checkout-button, button[name="checkout"], #checkout') : null;
    if (!b || !problem()) return;
    e.preventDefault();
    e.stopPropagation();
    var target = document.querySelector('.pbs-stylesel.missing') || document.getElementById('pbs-notes');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  function render() {
    css();
    killLeftovers();
    planNotes();
    mountPlan();
    mountDays();
    mountNotes();
    hideDupes();
    sync();
  }

  function boot() {
    loadCatalog()
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) { CART = c; render(); })
      .catch(function () { render(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('cart:updated', boot);
  document.addEventListener('cart:refresh', boot);

  var obs = new MutationObserver(function () {
    clearTimeout(window.__pbsT);
    window.__pbsT = setTimeout(render, 250);
  });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });
})();

